<script setup>
import {ref, onBeforeMount, defineProps, onMounted} from "vue";

import SubpageHeader from "@/components/organisms/header/SubpageHeader.vue";
import MainSection from "@/components/templates/mainSection.vue";
import MainFooter from "@/components/organisms/footer/MainFooter.vue";
import BodyContain from "@/components/molcules/layout/bodyContain.vue";
import PretendardText from "@/components/atoms/text/PretendardText.vue";
import { displayHooks } from "@/hooks/useDisplay";
import { router } from "@/router";
import { route } from "@/router/route";
import MenuApi from "@/api/menu";
import { getRouteByHomeLink, findMenuSection } from "@/util/menuUtil";
import { useToast } from "vue-toastification";
import SubjectApi from "@/api/subject";
const toast = useToast();

let useDisplayRef = ref(displayHooks);
let menuValue = ref("");

let mainSectionMenu = ref([]);

let courseInfo = ref({}); // 교과목 정보
let weekList = ref([]); // 주차별 수업내용

// let menuList = ref([]);

const props = defineProps({
  lctrShdlCd: String,
  operAcplCd: String
});

onBeforeMount(() => {
  getMenu();
  // getInfo();
});

const getMenu = async () => {
  try {
    const arr = [];

    const data = {
      exposureFlag: true,
    };

    const response = await MenuApi.get(data);
    if (response.data.data) {
      const sectionMenu = findMenuSection(response.data.data.content, "curriculum");
      const subMenu = sectionMenu?.subMenus || [];
      subMenu.map((item, index) => {
        if (item.contentsFlag) {
          arr.push({
            value: item.title,
            label: item.title,
            routeName: route.board + `/${item.boardId}`,
          });
        } else {
          arr.push({
            value: item.title,
            label: item.title,
            routeName: getRouteByHomeLink(item.homeLink) || route[`curriculum${index + 1}`],
          });
        }

        if (item.homeLink === "/curriculum02") {
          menuValue.value = item.title;
        }
        return;
      });

      mainSectionMenu.value = arr;
    }
  } catch (e) {
    toast("서버에 문제가 있습니다. 잠시후 다시 시도하세요.", {
      toastClassName: "toast-wrapper",
      position: "top-center",
      timeout: 2000,
      hideProgressBar: true,
      closeButton: false,
      icon: false,
    });
  }
};

onMounted(() => {
  setData();
});

async function setData() {
  try {
    let data = {
      lctrShdlCd : props.lctrShdlCd,
      operAcplCd : props.operAcplCd
    };

    let response = await SubjectApi.getKCultureCourseInfo(data);

    courseInfo.value = response.data.result.info[0];
    weekList.value = response.data.result.weekList;

  } catch(error) {
    console.log(error);
  }
}

const goMenu = () => {
  router.push(route.curriculum2);
};

</script>

<template>
  <SubpageHeader />
  <MainSection
      bgUrl="curriculum"
      :options="mainSectionMenu"
      :menuValue="menuValue"
      mainHeader="교육과정"
      subHeader01="Home"
      subHeader02="교육과정"
  />

  <BodyContain style="padding-bottom: 141px">
    <PretendardText class="intro-title" :style="`margin-top: ${ useDisplayRef.isMobile ? '60px' : !useDisplayRef.isMobile ? '80px' : '' }`">{{ courseInfo.sbcKrnm }}</PretendardText>
    <PretendardText class="text-24">기본정보</PretendardText>
    <div class="table">
      <div class="row">
        <div class="title-cell cell">제목</div>
        <div class="cell">{{ courseInfo.sbcKrnm }}</div>
      </div>
      <div class="row">
        <div class="title-cell cell">수준</div>
        <div class="cell">{{ courseInfo.grdNm }}</div>
      </div>
      <div class="row">
        <div class="title-cell cell">학점</div>
        <div class="cell">{{ courseInfo.gdptNm }}</div>
      </div>
      <div class="row">
        <div class="title-cell cell">교강사</div>
        <div class="cell">{{ courseInfo.pfList }}</div>
      </div>
    </div>
    <PretendardText class="text-24" style="margin-top: 80px">수업 진행 계획</PretendardText>
      <div class="table-scroll">
      <div class="scedule-table">
        <div class="row">
          <div class="title-cell cell first">주차</div>
          <div class="title-cell cell second">수업 내용</div>
          <div class="title-cell cell third">담당자</div>
          <div class="title-cell cell fourth">수업방식</div>
        </div>
        <div v-for="(item, index) in weekList" :key="index" class="row content-row">
          <div class="cell first">{{ index + 1 }}</div>
          <div class="cell second" style="white-space: pre-line;">{{ item.clasDtsCnkr ? item.clasDtsCnkr : item.clasSbjcKr}}</div>
          <div class="cell third">
            {{ (item.pfList && JSON.parse(item.pfList).length > 0 && JSON.parse(item.pfList)[0].usr_krnm)
              ? JSON.parse(item.pfList)[0].usr_krnm : "-" }}
          </div>
          <div class="cell fourth">
            {{ item.clasStleNm }}
          </div>
        </div>
      </div>
    </div>
    <div
        style="
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 20px;
      "
    >
      <div class="list-btn" @click="goMenu">목록</div>
      <div class="lms-btn">학습플랫폼(LMS) 바로가기</div>
    </div>
  </BodyContain>
  <MainFooter />
</template>

<style lang="scss" scoped>
.intro-title {
  width: 100%;
  color: $black;
  font-size: 32px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.6px;
  padding-bottom: 20px;
  border-bottom: 1px solid $line;
  margin-bottom: 20px;

  @include mobile {
    font-size: 20px;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
}

.text-16 {
  color: $g03;
  font-size: 16px;
  font-weight: 400;
  line-height: 140%; /* 16.8px */
  letter-spacing: -0.6px;
}

.text-24 {
  color: $g02;
  font-size: 24px;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
  letter-spacing: -0.6px;
  margin-bottom: 20px;

  @include mobile {
    font-size: 16px;
  }
}

.table {
  display: table;
  width: 100%;
  border-right : 1px solid $line;
  /* border-top: 1px solid $line; */
  /* border-bottom: 1px solid $line; */
}

.row {
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;

  @include mobile {
    height: 50px;
  }

  .cell {
    width: 100%;
    height: auto;
    display: table-cell;
    border: 1px solid $line;
    border-right: 0px;
    border-top: 0px;
    padding: 10px 20px;
    color: $g01;
    font-size: 18px;
    line-height: 130%;
    letter-spacing: -0.6px;
    min-height : 80px;
    align-content: center;

    @include mobile {
      font-size: 14px;
      height: 50px;
    }
  }

  .cell:first-child,
  .cell:nth-child(2),
  .cell:nth-child(3),
  .cell:nth-child(4) {
    border-top: 1px solid $line;
    border-bottom: 1px solid $line;
    border-collapse: collapse;
  }

  .title-cell {
    width: 150px;
    height: 80px;
    background-color: #f9f9f9;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    border-left: 0px;

    @include mobile {
      width: 80px;
      height: 50px;
    }
  }
}

.scedule-table {
  display: table;
  width: 100%;
  border-collapse: collapse;
  border-right : 1px solid $line;

  overflow: auto;

  .row {
    width: 100%;
    display: flex;
    align-items: stretch;
  }

  .first {
    width: 100px;
  }

  .second {
    width: 660px;
  }

  .third {
    width: 150px;
  }

  .fourth {
    width: 290px;
  }

  .content-row {
    .first,
    .second {
      font-weight: 700;
    }

    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .second {
      justify-content: flex-start;
    }
  }
}

.table-scroll {
  @include mobile {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 30px;
  }
}

.table-scroll::-webkit-scrollbar {
  width: 18px; /* 스크롤바의 너비 */
}

.table-scroll::-webkit-scrollbar-thumb {
  width: 6px;
  background: $primary4; /* 스크롤바의 색상 */
  border-radius: 999px;
  border: 6px solid #ffffff;
}

.table-scroll::-webkit-scrollbar-track {
  border-radius: 999px;
  background: #ffffff;
  border: 6px solid #ffffff;
}

.list-btn {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 10px;
  border: 1px solid $g05;
  font-family: Pretendard;
  color: $primary4;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.6px;
  cursor: pointer;
}

.lms-btn {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 10px;
  border: 1px solid #54966e;
  font-family: Pretendard;
  color: #54966e;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.6px;
  cursor: pointer;
}
</style>
